import { Outlet } from "react-router-dom";
import { useState } from "react";
import useLocalStorage from "use-local-storage";
import Header from './sections/Header';
import Background from "./sections/Background";
import Toggle from "./Toggle";

const Layout = (props) => {
  const preference = window.matchMedia("(prefers-color-scheme: dark)").matches;

  const [isDark, setisDark] = useState(preference);
  const attributes = {
    isDark: isDark,
    setisDark: () => setisDark(!isDark),
    target:"theme",
    labelContent:"Dark Mode",
  }
  return (
    <>
      <div data-theme={isDark ? "dark" : "light"}>
        <Header attributes={attributes} />
        <main>  
          <Outlet />
        </main>
        {/* <Background theme={isDark ? "light" : "dark"} /> */}
        <Background isDark={isDark} />
      </div>
    </>
  )
};

export default Layout;